import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './ProjectInvitationDecline.scss';

class ProjectInvitationDecline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    this.setState({ message: target.value });
  }

  handleSubmit() {
    const { formUrl, csrfToken } = this.props;
    const { message } = this.state;

    return putRequest(
      formUrl,
      { status: 'rejected', message },
      csrfToken,
    ).then(() => {
      window.location.reload();
    });
  }

  render() {
    const { message } = this.state;
    return (
      <ModalTrigger
        triggerText="Decline Opportunity"
        buttonStyles="secondary full-width"
        submitButtonText="Decline"
        handleSubmit={this.handleSubmit}
        submitDisabled={!message}
        triggerType="link"
        cancelButton={false}
        idKey="decline-project-invitation-modal"
      >
        <div className="style-guide">
          <h1 className="mb-8">Decline project</h1>
          <div className="body-text-2 mb-3 ">
            Share with Clora the reasons why you are not interested in this opportunity to help us
            improve your marketplace experience.
          </div>
          <div className="body-text-2 medium-weight mb-8">
            Why you are not interested in this opportunity?
            <span className="required" />
          </div>
          <textarea
            value={message}
            className="form-control"
            placeholder="Type here..."
            name="message"
            id="message"
            rows="4"
            onChange={this.handleInputChange}
          />
        </div>
      </ModalTrigger>
    );
  }
}

ProjectInvitationDecline.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
};

export default ProjectInvitationDecline;
